import { Option } from '@/models/interfaces';

const CAN_ZIP_TABLE: { [code: string]: string } = {
  A: 'terre-neuve-et-labrador',
  B: 'nouvelle-ecosse',
  C: 'ile-du-prince-edouard',
  E: 'nouveau-brunswick',
  G: 'quebec',
  H: 'quebec',
  J: 'quebec',
  K: 'ontario',
  L: 'ontario',
  M: 'ontario',
  N: 'ontario',
  P: 'ontario',
  R: 'manitoba',
  S: 'saskatchewan',
  T: 'alberta',
  V: 'colombie-britannique',
};

const CAN_OPTIONS: Array<Option> = [
  { value: 'quebec', label: 'Québec' },
  { value: 'alberta', label: 'Alberta' },
  { value: 'colombie-britannique', label: 'Colombie-Britannique' },
  { value: 'ile-du-prince-edouard', label: 'Ile du Prince Édouard' },
  { value: 'manitoba', label: 'Manitoba' },
  { value: 'nouveau-brunswick', label: 'Nouveau-Brunswick' },
  { value: 'nouvelle-ecosse', label: 'Nouvelle-Écosse' },
  { value: 'ontario', label: 'Ontario' },
  { value: 'saskatchewan', label: 'Saskatchewan' },
  { value: 'terre-neuve-et-labrador', label: 'Terre-Neuve-et-Labrador' },
];

function getCanadianOSM(input: string): { aL6: string; aL4: string } | null {
  let aL4 = CAN_ZIP_TABLE[input];
  if (!aL4) aL4 = CAN_OPTIONS.find((it) => it.value === input)?.label ?? '';
  return aL4 ? { aL4, aL6: '' } : null;
}

export { CAN_OPTIONS, getCanadianOSM };
